var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "fill", attrs: { "title-color": "primary" } },
        [
          _c("div", [
            _c("div", { staticClass: "row fill" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-md-4 shadow bg-white rounded overflow-y-scroll tree-panel"
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "transition",
                        { attrs: { "enter-active-class": "animated fadeIn" } },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    !Object.keys(_vm.getRepositories).length &&
                                    _vm.loading,
                                  expression:
                                    "!Object.keys(getRepositories).length && loading"
                                }
                              ],
                              staticClass: "w-100"
                            },
                            [
                              _c("b-skeleton", {
                                staticClass:
                                  "bg-grey-light border-0 w-48 h-8 mb-3",
                                attrs: { type: "input", animation: "fade" }
                              }),
                              _c("b-skeleton", {
                                staticClass:
                                  "bg-grey-light border-0 w-32 h-8 mb-3",
                                attrs: { type: "input", animation: "fade" }
                              }),
                              _c("b-skeleton", {
                                staticClass:
                                  "bg-grey-light border-0 w-64 h-8 mb-3",
                                attrs: { type: "input", animation: "fade" }
                              }),
                              _c(
                                "div",
                                { staticClass: "d-flex w-100" },
                                [
                                  _c("b-skeleton", {
                                    staticClass:
                                      "bg-grey-light border-0 w-3 h-3 ml-3",
                                    attrs: { type: "text", animation: "fade" }
                                  }),
                                  _c("b-skeleton", {
                                    staticClass:
                                      "bg-grey-light border-0 w-3 h-3 ml-1",
                                    attrs: { type: "text", animation: "fade" }
                                  }),
                                  _c("b-skeleton", {
                                    staticClass:
                                      "bg-grey-light border-0 w-3 h-3 ml-1",
                                    attrs: { type: "text", animation: "fade" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                !Object.keys(_vm.getRepositories).length &&
                                !_vm.loading,
                              expression:
                                "!Object.keys(getRepositories).length && !loading"
                            }
                          ]
                        },
                        [_c("NewRepository")],
                        1
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: Object.keys(_vm.getRepositories).length,
                              expression: "Object.keys(getRepositories).length"
                            }
                          ],
                          staticClass: "w-100"
                        },
                        [
                          _c(
                            "transition-group",
                            {
                              attrs: {
                                "enter-active-class": "animated fadeIn",
                                "leave-active-class": "animated fadeOut"
                              }
                            },
                            _vm._l(_vm.getRepositories, function(repository) {
                              return _c("RepositoriesTree", {
                                key: repository.repositorioId,
                                staticClass: "item",
                                attrs: { repository: repository }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm.getRepositories.length <= 0
                        ? _c("span", [
                            _vm._v("No tienes acceso a ningun repositorio.")
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "col-md-8", attrs: { id: "main-panel" } },
                [
                  _c(
                    "b-overlay",
                    { attrs: { show: _vm.loading } },
                    [
                      _c("NavigationPanel", { attrs: { toggle: _vm.toggle } }),
                      _c("vs-divider"),
                      _vm.getSelectedElement
                        ? _c("DetailsPanel", {
                            attrs: { detailItem: _vm.detailItem },
                            on: {
                              toggleRepositoryViewPanel: function($event) {
                                return _vm.toggleView()
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }